import { EarnRewardsBanner } from '../components/earn-rewards-banner/EarnRewardsBanner'
import { OngoingCampaignsPanel } from '../components/ongoing-campaigns-panel/OngoingCampaignsPanel'
import { UseOngoingCampaignsResult } from '../logic/useOngoingCampaigns'
import { tokenLogos } from '@/config/chain/configs/mainnet/assets'
import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { IconStack } from '@/ui/molecules/icon-stack/IconStack'

export interface GuestViewProps {
  ongoingCampaignsResult: UseOngoingCampaignsResult
  openConnectModal: () => void
}

export function GuestView({ ongoingCampaignsResult, openConnectModal }: GuestViewProps) {
  return (
    <PageLayout>
      <h1 className="typography-heading-1">Rewards</h1>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[11fr_5fr]">
        <div className="grid grid-cols-1 gap-5">
          <OngoingCampaignsPanel
            ongoingCampaignsResult={ongoingCampaignsResult}
            isGuestMode={true}
            className="self-start"
          />
          <ConnectWalletPanel openConnectModal={openConnectModal} />
        </div>
        <EarnRewardsBanner className="self-start" />
      </div>
    </PageLayout>
  )
}

function ConnectWalletPanel({ openConnectModal }: { openConnectModal: () => void }) {
  const rewards = [tokenLogos.usds, tokenLogos.spk, tokenLogos.red]
  return (
    <Panel spacing="m" className="flex min-h-60 flex-col gap-9 sm:min-h-72">
      <div className="my-auto flex flex-col items-center gap-5">
        <IconStack size="lg" items={rewards} iconBorder="white" />
        <div className="flex flex-col items-center gap-2 text-center">
          <div className="typography-heading-5 text-primary">Start earning rewards</div>
          <div className="typography-body-3 max-w-[32ch] text-secondary">
            Unlock rewards by joining campaigns. Connect your wallet to get started!
          </div>
          <Button size="l" variant="secondary" className="mt-4 w-full" onClick={openConnectModal}>
            Connect Wallet
          </Button>
        </div>
      </div>
    </Panel>
  )
}
